import {videoPreviewOptions} from "./videoPreviewOptions";

export function getVideoSlidesFromDOM(parse = false){
    let videoSlidesRawFromServer = jQuery(videoPreviewOptions.handlers.videoSlidesJSONBlobHandler);
    let json;

    if (videoSlidesRawFromServer.length > 0) {
        json = videoSlidesRawFromServer.text();
    } else if (window.debug) {
        console.log('Video slide JSON was not found!');
    }

    if (parse && json) {
        json = JSON.parse(json);
        if (!json) {
            if (window.debug) {
                console.log('Unable to parse video slides JSON');
            }
        }
    }

    return json;
}